"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDGET_DROPZONE_SIZE_INFO_DEFAULT = exports.KPI_WIDGET_SIZE_INFO_DEFAULT = exports.KPI_WIDGET_SIZE_INFO_DEFAULT_LEGACY = exports.INSIGHT_WIDGET_SIZE_INFO_DEFAULT = exports.INSIGHT_WIDGET_SIZE_INFO_DEFAULT_LEGACY = exports.MIDDLE_VISUALIZATION_HEIGHT = exports.MIN_VISUALIZATION_HEIGHT = exports.MAX_VISUALIZATION_HEIGHT = exports.DASHBOARD_LAYOUT_DEFAULT_VIS_HEIGHT_PX = exports.DASHBOARD_LAYOUT_DEFAULT_KPI_HEIGHT = exports.DASHBOARD_LAYOUT_DEFAULT_VIS_HEIGHT = void 0;
exports.DASHBOARD_LAYOUT_DEFAULT_VIS_HEIGHT = 22.5;
exports.DASHBOARD_LAYOUT_DEFAULT_KPI_HEIGHT = 12;
/**
 * @internal
 */
exports.DASHBOARD_LAYOUT_DEFAULT_VIS_HEIGHT_PX = 450;
exports.MAX_VISUALIZATION_HEIGHT = 40;
exports.MIN_VISUALIZATION_HEIGHT = 12;
exports.MIDDLE_VISUALIZATION_HEIGHT = 22;
/**
 * @internal
 */
exports.INSIGHT_WIDGET_SIZE_INFO_DEFAULT_LEGACY = {
    width: {
        min: 4,
        default: 6,
    },
    height: {
        default: exports.DASHBOARD_LAYOUT_DEFAULT_VIS_HEIGHT,
    },
};
/**
 * @internal
 */
exports.INSIGHT_WIDGET_SIZE_INFO_DEFAULT = {
    width: {
        min: 4,
        default: 6,
    },
    height: {
        default: 22,
        min: 22,
        max: 40,
    },
};
/**
 * @internal
 */
exports.KPI_WIDGET_SIZE_INFO_DEFAULT_LEGACY = {
    width: {
        min: 2,
        default: 2,
    },
    height: {
        default: exports.DASHBOARD_LAYOUT_DEFAULT_KPI_HEIGHT,
        min: exports.DASHBOARD_LAYOUT_DEFAULT_KPI_HEIGHT,
        max: exports.DASHBOARD_LAYOUT_DEFAULT_KPI_HEIGHT,
    },
};
/**
 * @internal
 */
exports.KPI_WIDGET_SIZE_INFO_DEFAULT = {
    width: {
        min: 2,
        default: 2,
    },
    height: {
        default: 11,
        min: 9,
        max: 40,
    },
};
/**
 * @internal
 */
exports.WIDGET_DROPZONE_SIZE_INFO_DEFAULT = exports.KPI_WIDGET_SIZE_INFO_DEFAULT;
//# sourceMappingURL=constants.js.map